import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTopMedium"><Path d="M11.7246 7.58224C11.9187 7.45407 12.1826 7.47583 12.3535 7.64669L18.8535 14.1467C19.0487 14.342 19.0487 14.6585 18.8535 14.8537C18.6582 15.049 18.3417 15.049 18.1464 14.8537L12 8.70724L5.85348 14.8537C5.65822 15.049 5.34171 15.049 5.14645 14.8537C4.95118 14.6585 4.95118 14.342 5.14645 14.1467L11.6464 7.64669L11.7246 7.58224Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopMedium;
